let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("knC8N")).then(() => parcelRequire('dwiQZ'));